import React from 'react';
import DwriSystemHeader from './sections/DwriSystemHeader';
import DwriManagementInfo from './sections/DwriManagementInfo';
import DwriAnnualUseSection from './sections/DwriAnnualUseSection';
import DwriPeakDaySection from './sections/DwriPeakDaySection';
import DwriPeakMonthSection from './sections/DwriPeakMonthSection';
import DwriSourceDataSection from './sections/DwriSourceDataSection';
import '../dwri.css';

const DwriDataTab = ({ systemName, sizingInfo, waterUses, sourceRecords, peakDayData, peakMonthData, loading, errors, selectedSources }) => {
    return (
        <div className="utah-design-system">
            <DwriSystemHeader
                systemName={systemName}
                loading={loading.info}
            />
            <DwriManagementInfo
                sizingInfo={sizingInfo}
                loading={loading.info}
                error={errors.info}
            />
            <br />
            <DwriAnnualUseSection
                waterUses={waterUses}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
            <DwriPeakDaySection
                peakDayData={peakDayData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriPeakMonthSection
                peakMonthData={peakMonthData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriSourceDataSection
                sourceRecords={sourceRecords}
                selectedSources={selectedSources}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
        </div>
    );
};

export default DwriDataTab;
